import React from 'react';
import { user as userType } from 'api/users/types';
import { Link } from 'react-router-dom';
import i8a from 'assets/images/i8a.svg';
import i9a from 'assets/images/i9a.svg';
import i35 from 'assets/images/i35.svg';

const propTypes = {
  user: userType.isRequired
};

class ProfilePopup extends React.Component {
  render() {
    const { user } = this.props;

    return (
      <div className="nav-toppanel--user-profile-dropdown">
        <div className="nav-toppanel--user-profile-person">
          <div className="avatar-outer--sm-box a-bg-7">
            <div className="avatar-inner-md-box">{user.initials}</div>
          </div>
          <div className="nt--user-name">{user.full_name}</div>
        </div>
        <div className="nav-toppanel--profile-link-list">
          <div className="nav-toppanel--profile-link">
            <Link to="/my-profile/details">
              <span className="nt-profile-link--icon">
                <img src={i8a} alt=""/>
              </span>
              <span>Ustawienia profilu</span>
            </Link>
          </div>
          <div className="nav-toppanel--profile-link">
            <Link to="/my-profile/password-set">
              <span className="nt-profile-link--icon">
                <img src={i9a} alt=""/>
              </span>
              <span>Zmiana hasła</span>
            </Link>
          </div>
        </div>
        <div>
          <div className="btn-container btn-container--btns-on-center">
            <Link to="/logout" className="stroke-btn" type="submit">
              <span>Wyloguj się</span>
              <span className="nt-profile-btn--icon-r">
                <img src={i35} alt=""/>
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

ProfilePopup.propTypes = propTypes;
export default ProfilePopup;



// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/ProfilePopup.jsx